import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AdminManagerService } from "../services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { DwConfigService, DwConfigServiceToken, getParameterByName } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";

@Injectable()
export class SchoolOverrideHttpInterceptor implements HttpInterceptor {


    constructor(private adminManagerService: AdminManagerService, private router: Router,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
    ) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop: string]: string } = {};

        // The server validates whether the current user may override schools. Do not
        // gate this header on client permissions because those can initialize after
        // the first authenticated API requests during application startup.
        if (request.url.indexOf(this.configService.coreConfig.apiRoot) !== -1) {
            const aviatorUser = this.adminManagerService.getAviatorUser();

            if (aviatorUser?.FlightSchoolId) {
                headers['AVIATOR-SCHOOL-ID-OVERRIDE'] = aviatorUser.FlightSchoolId.toString();
            }
        }

        request = request.clone({
            headers: request.headers,
            setHeaders: headers
        })

        return next.handle(request);
    }
}
